import { useSelector } from 'react-redux';
import {
  LegendRow,
  LegendDot,
  LegendText,
  LegendLeft,
  LegendValue,
  ChartWrapper,
  ChartContainer,
  LegendContainer,
} from './studentsInComplianceChartStyled';
import DefaultDoughnutChart from 'examples/Charts/DoughnutCharts/DefaultDoughnutChart';

const StudentsInComplianceChart = ({ height }) => {
  const onlineAttendanceStats = useSelector((state) => state.statsData);

  const studentsInComplianceChartData = {
    labels: ['Passing', 'Failing'],
    datasets: {
      label: 'Compliance',
      backgroundColors: ['success', 'error'],
      data: [
        onlineAttendanceStats?.numStudentsInCompliancePassing || 0,
        onlineAttendanceStats?.numStudentsInComplianceFailing || 0,
      ],
    },
    cutout: 70,
  };

  return (
    <ChartContainer height={height}>
      <ChartWrapper>
        <DefaultDoughnutChart
          chart={studentsInComplianceChartData}
          height={height || '10rem'}
        />
      </ChartWrapper>

      <LegendContainer>
        <LegendRow>
          <LegendLeft>
            <LegendDot color="#4CAF50" />
            <LegendText>Passing</LegendText>
          </LegendLeft>
          <LegendValue>
            {onlineAttendanceStats?.numStudentsInCompliancePassing || 0}
          </LegendValue>
        </LegendRow>

        <LegendRow>
          <LegendLeft>
            <LegendDot color="#F44335" />
            <LegendText>Failing</LegendText>
          </LegendLeft>
          <LegendValue>
            {onlineAttendanceStats?.numStudentsInComplianceFailing || 0}
          </LegendValue>
        </LegendRow>
      </LegendContainer>
    </ChartContainer>
  );
};

export default StudentsInComplianceChart;
